import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../../Utils/ApiConnect";
export default class Formula extends Component {
  constructor() {
    super();
    this.state = {
      formulaData: [],
    };
    this.columns = [
      {
        key: "name",
        text: "Product Name",
        sortable: true,
      },
      {
        key: "category",
        text: "Material",
        sortable: true,
        cell: (record) => {
          return record.material.map((mat, index) => (
            <p key={index}>
              {mat}
              <br />
            </p>
          ));
        },
      },
      {
        key: "qty",
        text: "Qty",
        sortable: true,
        cell: (record) => {
          return record.qty.map((mat, index) => (
            <p key={index}>
              {mat}
              {record.unit[index]}
              <br />
            </p>
          ));
        },
      },
      {
        key: "production",
        text: "Production",
        sortable: true,
        cell: (record) => {
          return record.production + "" + record.prd_unit;
        },
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,
        align: "center",
        sortable: false,
        cell: (record) => {
          return (
            <React.Fragment>
              <button
                className="table-action btn btn-square btn-pure hover-info"
                // onClick={() => <EditProduct product={record} />}
              >
                <span className="material-icons-outlined">visibility</span>
              </button>
              <Link
                className="table-action btn btn-square btn-pure hover-warning"
                // to={`${url}/Edit/${record.id}`}
              >
                <span className="material-icons-outlined">edit_note</span>
              </Link>
              <button
                disabled={false}
                className="table-action btn btn-square btn-pure hover-danger"
                // onClick={(e) => deleteProduct(e, record.id)}
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 10,
      length_menu: [10, 20, 50],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchFormulas();
  }
  fetchFormulas() {
    ApiConnect.get("/Module/Inventory/Consumption/Formula")
      .then((response) => {
        this.setState({ formulaData: response.data });
      })
      .catch((error) => console.log(error));
  }
  render() {
    return (
      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="dataTables_wrapper">
                <ReactDatatable
                  className="table table-separated"
                  config={this.config}
                  records={this.state.formulaData}
                  columns={this.columns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
